import { usersInfoRequest } from "../../services/requests/auth";
import { $snack } from "../../services/snack";
const { sessionLoadFailure } = require("../../utils/userState");

export default function auth({ next, store }) {
  return new Promise((resolve, reject) => {
    if (!store.getters.getIsLogged) {
      return reject(next({ name: "login" }));
    }

    if (store.getters.getIsLogged && !store.getters.getUser) {
      return usersInfoRequest()
        .then((res) => {
          store.dispatch("setUser", res.data.data);
          let address = res.data.data.address;
          if (address) {
            address = {
              ...address,
              num: address.number,
            };
          }
          store.dispatch("setAddress", address);
          resolve();
        })
        .catch((error) => {
          if (sessionLoadFailure(error) === "denied") {
            store.dispatch("clearSession", false);
            $snack.error("Faça seu login novamente");
            return reject(next({ name: "login" }));
          }

          $snack.error(
            "Não foi possível carregar sua sessão. Verifique a conexão e tente novamente."
          );
          return reject(next(false));
        });
    }

    return resolve();
  });
}
